module.exports = __webpack_public_path__ + "img/view_device_c2_one.61012b98.jpg";